import gql from 'graphql-tag';

export default gql`
  query getTenderTypePreferredCardHeaderModal {
    getTenderTypePreferredCardHeaderModal {
      enable
      title
      body {
        text
      }
    }
  }
`;
